import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export interface ISummaryStateSlice {
  summary: ISummary | null;
  summaryState: IReduxLoadingState;
  dotPhraseListResidentNote: any[];
}

const name = "summary";

export const initialState: ISummaryStateSlice = {
  summary: null,
  summaryState: "pending",
  dotPhraseListResidentNote: [],
};

export const summarySlice = createSlice({
  name,
  initialState,
  reducers: {
    setSummaryState: (
      state,
      action: PayloadAction<Partial<ISummaryStateSlice>>
    ) => ({
      ...state,
      ...action.payload,
    }),
    addEscalationSummary: (state, action: PayloadAction<string>) => {
      if (state.summary) {
        return {
          ...state,
          summary: {
            ...state.summary!,
            clinical_alerts_details: {
              total_count:
                state.summary!.clinical_alerts_details.total_count + 1,
              rooms_list: [
                action.payload,
                ...state.summary!.clinical_alerts_details.rooms_list,
              ],
            },
          },
        };
      }
    },
    addFlagSummary: (state, action: PayloadAction<string>) => {
      if (state.summary) {
        return {
          ...state,
          summary: {
            ...state.summary!,
            psn_details: {
              total_count: state.summary!.psn_details.total_count + 1,
              rooms_list: [
                action.payload,
                ...state.summary!.psn_details.rooms_list,
              ],
            },
          },
        };
      }
    },
    addBedExitSummary: (state, action: PayloadAction<string>) => {
      if (state.summary) {
        return {
          ...state,
          summary: {
            ...state.summary!,
            bed_exit_details: {
              total_count: state.summary!.bed_exit_details.total_count + 1,
              rooms_list: [
                action.payload,
                ...state.summary!.bed_exit_details.rooms_list,
              ],
            },
          },
        };
      }
    },
  },
});

export const {
  setSummaryState,
  addBedExitSummary,
  addEscalationSummary,
  addFlagSummary,
} = summarySlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: ["summary"],
  },
  summarySlice.reducer
);

export default persistedReducer;
